import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbTipoRecurso } from "app/abstract/full-pages/equipamento/tipo-recurso.abstract";

@Injectable({ providedIn: 'root' })
export class TipoRecursoService extends AbTipoRecurso {
    prefixo = "tipos_recursos";

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public getAllAtivos() {
        return this.get(`${this.prefixo}/all/`);
    }

}